var _defs, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyxdLogoHeaderBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.96 112.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #231f20;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8px;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "56.07 107.86 5.77 54.88 58.74 4.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyxdLogoHeaderBack);
export default __webpack_public_path__ + "static/media/fyxd-logo-header-back.74d3acd23a3cd1a6213d4814926e5176.svg";
export { ForwardRef as ReactComponent };